// extracted by mini-css-extract-plugin
export default {"hidden":"FiasOverrider-module--hidden--mn0Hf"};